import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=0c473dbc&scoped=true&"
import script from "./workDetail.vue?vue&type=script&lang=tsx&"
export * from "./workDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=0c473dbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c473dbc",
  null
  
)

export default component.exports